import axios, { AxiosResponse, AxiosRequestConfig } from "axios";
import { BASE_URL, ADMIN_URL, NEST_ADMIN_URL } from "../config";
import { TokenManager } from "./tokenManager";

export type ApiResponse<T> = T | AxiosResponse<T> | null;

// 로딩 상태 관리를 위한 변수들
let loadingCount = 0;
let setLoadingState: ((loading: boolean) => void) | null = null;

// 로딩 상태 설정 함수 등록 (앱 초기화 시 호출) 리코일 못 써서 그래요
export function setLoadingStateSetter(setter: (loading: boolean) => void) {
  setLoadingState = setter;
}

// 로딩 상태 업데이트 함수
function updateLoadingState() {
  if (setLoadingState) {
    setLoadingState(loadingCount > 0);
  }
}

// 로딩 시작
function startLoading() {
  loadingCount++;
  updateLoadingState();
}

// 로딩 종료
function endLoading() {
  loadingCount = Math.max(0, loadingCount - 1);
  updateLoadingState();
}

interface ApiRequestOptions {
  data?: any;
  params?: any;
  headers?: any;
  fullResponse?: boolean;
  requiresAuth?: boolean;
}

const createApiRequest =
  (baseUrl: string) =>
  async <T>(
    method: string,
    endpoint: string,
    options: ApiRequestOptions = {}
  ): Promise<ApiResponse<T>> => {
    const {
      data,
      params,
      headers = {},
      fullResponse = false,
      requiresAuth = true,
    } = options;
    const token = TokenManager.getToken();

    if (requiresAuth && !token) return null;
    if (endpoint.includes("/api/friend-recommend/allListByUserId")) return null;
    // 로딩 시작
    startLoading();
    const config: AxiosRequestConfig = {
      method,
      url: `${baseUrl}${endpoint}`,
      headers: {
        ...(requiresAuth && token && { Authorization: `Bearer ${token}` }),
        ...headers,
      },
      data,
      params,
    };

    try {
      const response: AxiosResponse<T> = await axios(config);
      return fullResponse ? response : response.data;
    } catch (error) {
      console.error("API request failed:", error);
      return null;
    } finally {
      endLoading();
    }
  };

export const apiRequest = createApiRequest(
  process.env.REACT_APP_API + BASE_URL
);
export const adminApiRequest = axios.create({
  baseURL: process.env.REACT_APP_API + ADMIN_URL,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

export const nestAdminApiRequest = axios.create({
  baseURL: process.env.REACT_APP_API + NEST_ADMIN_URL,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

adminApiRequest.interceptors.request.use(
  (config) => {
    startLoading();
    return config;
  },
  (error) => {
    endLoading();
    return Promise.reject(error);
  }
);

adminApiRequest.interceptors.response.use(
  (response) => {
    endLoading();
    return response;
  },
  (error) => {
    endLoading();
    return Promise.reject(error);
  }
);

nestAdminApiRequest.interceptors.request.use(
  (config) => {
    startLoading();
    return config;
  },
  (error) => {
    endLoading();
    return Promise.reject(error);
  }
);

nestAdminApiRequest.interceptors.response.use(
  (response) => {
    endLoading();
    return response;
  },
  (error) => {
    endLoading();
    return Promise.reject(error);
  }
);
